module.exports = __webpack_public_path__ + "img/11.3e715da2.png";